import styled from '@emotion/styled';

const Align = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

const Title = styled.span`
    font-size: 16px;
    font-weight: 700;
`;

const Label = styled.span`
    font-size: 12px;
    min-width: 20px;
    color: #fff;
    padding: 6px 4px;
    background-color: #ff4500;
    border-radius: 5px;
    line-height: 8px;
    white-space: nowrap;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
`;

interface Props {
    title: string;
    isRequired?: boolean;
}

/**
 * フォームのラベル
 * 例:
 *  お名前 [必須]
 *  ユーザー名 [任意]
 */
export const FormLabel: React.FC<Props> = ({ title, isRequired }) => {
    return (
        <Align>
            <Title>{title}</Title>
            {isRequired && <Label>必須</Label>}
        </Align>
    );
};
